export enum MetricColorDirection {
	NONE = 'noColor',
	REVERSED = 'reversed',
	DIRECT = 'direct'
}